import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-copy-project-warning-notice',
  templateUrl: './copy-project-warning-notice.component.html',
  styleUrls: ['./copy-project-warning-notice.component.css']
})
export class CopyProjectWarningNoticeComponent {

  @Input() message: string = "";
}
